import { validateAndSanitizeURLParams } from '@/utils/urlValidation';
import { useLocation } from 'react-router-dom';

type UseURLSearchParams = {
  audienceId: string;
  audienceType: string;
  categoryId: string | null;
  categoryName: string | null;
};

export const useURLSearchParams = (): UseURLSearchParams => {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);

  const validatedParams = validateAndSanitizeURLParams(searchParams);

  return validatedParams;
};
